export const opgaverData = [
  {
    slug: "opbygning-af-terrasse",
    menuTitle: "Opbygning af terrasse",
    title: "Opbygning af terrasse - Hobro, Hadsund & Arden - Få et tilbud",
    metaDescription: "Vi tilbyder opbygning af terrasse efter dine behov og ønsker, til private og erhvervskunder. Kontakt os i dag og få et uforpligtende tilbud.",
    heading: "Opbygning af terrasse",
    subtitle: "Opbygning af terrasse i Hobro, Arden & Hadsund",
    sections: [
      {
        text: `Drømmer du om at få en flot stor opbygning af terrasse i haven med eller uden støttemur? Er du i tvivl om hvordan du får udnyttet pladsen bedst, og hvilket materiale din terrasse skal være i?\n\nTerrassen er det helt perfekte sted at bruge de lyse sommeraftener, med vennerne og grillhygge.\n\nDu har derfor en virkelig god mulighed, for at få lavet din drømme terrasse i sten.\n\nHos Elmegaarden Have og Anlæg arbejder vi udelukkende terrasseopbygninger efter dine behov og ønsker, til både private og erhvervskunder i og omkring Hobro, Arden & Hadsund.`
      },
      {
        heading: "Tænk kreativt med din opbygning af terrasse",
        text: `Vi har udarbejdet og stået for lægning af terrasser igennem mange år, derfor kan vi lægge en terrasse ud fra ethvert budget. Vi har et stort fokus på at få en god dialog med dig som kunde fra start til slut, da dette udelukkende giver det bedste slutresultat.\n\nVi leverer udelukkende terrasser af højeste kvalitet, og med materialer og belægninger, der er af høj kvalitet. Du kan vælge mellem flere forskellige slags detaljer, såsom terrasser i haveniveau og overdækket terrasser. Alt efter hvad jeres behov er.`
      },
      {
        heading: "Skab den perfekte terrasse i sten med professionel opbygning",
        text: `Når det kommer til opbygning af terrasser, er det vigtigt at vælge det rigtige materiale og design for at skabe det perfekte udendørs rum.\n\nVores team af erfarne anlægsgartnere er specialiserede i lægning af terrasser i forskellige stilarter og materialer, herunder træ, komposit og sten.\n\nVi tager hensyn til dine præferencer, budget og det overordnede udseende af din have for at skabe en terrasse, der passer perfekt til dit hjem.`
      },
      {
        heading: "Hvorfor vælge os til opbygning af din terrasse?",
        text: `Når det kommer til at vælge det rigtige firma til opbygning af terrasse, er der flere gode grunde til at vælge os.\n\nVi er dedikerede til at levere enestående kvalitet og skabe resultater, der vil overgå dine forventninger. Her er nogle af de vigtigste grunde til at vælge os:`,
        bullets: [
          "Erfarne landskabsarkitekter og håndværkere.",
          "Skræddersyede løsninger tilpasset dine behov.",
          "Professionel installation og holdbare resultater.",
          "Materialer af høj kvalitet."
        ],
        afterText: `Passion og service går hånd i hånd omkring vores arbejde, og vi er her for at guide og rådgive dig gennem hele processen, fra designfasen til den endelige installation.\n\nVores mål er at sikre, at du er fuldt ud tilfreds med resultatet af din terrasseopbygning.`
      },
      {
        heading: "Få din drømmeterrasse med vores ekspertise i opbygning af terrasser",
        text: `Vi ønsker at du får lige den opbygning af terrasse du drømmer om. Det er dog vigtigt for husets og helhedsdesignet at din terrasse matcher både haven og huset.\n\nVi forstår, at hver løsning er unik, og derfor tilbyder vi skræddersyede løsninger, der passer til din livsstil. Ønsker du en stor terrasse til familiehygge? Eller måske en lille, intim terrasse til afslapning?\n\nUanset hvilken stil og størrelse du ønsker, er vi her for at hjælpe.\n\nVores eksperter vil rådgive dig om valg af materialer, farver og mønstre, der bedst passer til dine ønsker og behov.`
      },
      {
        heading: "Kontakt os og få et tilbud på opbygning af din terrasse",
        text: `Skal du have en ny opbygning af terrassen? så kan vi komme ud og kigge på det sammen med dig, og rådgive og vejlede i forhold til hvad der ville være bedst og det mest optimale ud fra jeres behov, samt haven.\n\nDu er velkommen til at ringe til os på 20 66 15 17 eller sende en mail til rasmus@elmegaardenhaveoganlaeg.dk og få et tilbud.\n\nVi ser frem til at udføre en professionel lægning af terrasse hjemme hos dig.`
      }
    ],
    galleryImages: [
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/terrasse-i-sten_34f4226c.jpg",
        alt: "Terrasse i sten"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/terrasseopbygning.jpg",
        alt: "Terrasseopbygning"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/terrasse-i-niveauer.jpg",
        alt: "Terrasse i niveauer"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/opbygning-af-terrasse-til-hus.jpg",
        alt: "Opbygning af terrasse til hus"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/ny-opbygning-af-terrasse-i-brosten.jpg",
        alt: "Ny opbygning af terrasse i brosten"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/terrasseopbygning-med-stoettemur.jpg",
        alt: "Terrasseopbygning med støttemur"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/professionel-opbygning-af-terrasse.jpg",
        alt: "Professionel opbygning af terrasse"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/opbygning-af-terrasse.jpg",
        alt: "Opbygning af terrasse"
      }
    ]
  },
  {
    slug: "ny-indkoersel",
    menuTitle: "Ny indkørsel",
    title: "Lægning af indkørsel i Hobro, Arden & Hadsund → Ring i dag",
    metaDescription: "Skal du have lagt en ny indkørsel? eller skal den gamle friskes op? Så kontakt os gerne i dag og få et tilbud.",
    heading: "Ny indkørsel",
    subtitle: "Ny indkørsel i Hobro, Arden & Hadsund",
    sections: [
      {
        text: `Mangler du også en ny, funktionel og flot indkørsel til dit hus i Hobro, Arden, Hadsund og omegn?\n\nDer er et hav af muligheder når man skal have lagt en ny indkørsel, der er en masse muligheder i forhold til valg af sten og fliser, samt designet. Som udgangspunkt anbefaler vi at det passer med resten af haven og husets facade.\n\nInden vi går i gang med arbejdet, gør vi meget ud af at have en god dialog med vores kunder omkring lige netop designet, valg af materiale som sten osv.\n\nSå vi ligesom har forventningsafstemt inden vi begynder arbejdet, da dette helt klart vil give de bedste og mest optimale resultater.`
      },
      {
        heading: "Hvad er prisen på anlægning af en ny indkørsel?",
        text: `Du kan ikke finde en konkret pris på belægning af indkørsel online, da dette afhænger af designet samt hvilke fliser og generelt materialer der skal anvendes til projektet.\n\nDog garantere vi altid konkurrencedygtige priser til vores kunder.`
      },
      {
        heading: "Skab et imponerende første indtryk med en ny indkørsel",
        text: `En ny indkørsel kan have stor indvirkning på førstehånds indtrykket af dit hjem. Det er det første gæster ser, når de besøger dig, og det kan være med til at skabe en imponerende atmosfære.\n\nVores erfarne hold af anlægsgartnere hos Elmegaarden Have og Anlæg, vil samarbejde tæt med dig for at skabe den perfekte indkørsel, der matcher dine ønsker og behov.\n\nVi har ekspertisen og erfaringen, til at omsætte dine drømme til virkelighed og skabe en ny indkørsel, der vil imponere enhver.`
      },
      {
        heading: "Skal vi stå for din nye indkørsel?",
        text: `Elmegaarden Have og Anlæg har mange års erfaring i branchen indenfor belægningsarbejde, herunder terrasser og indkørsler. Vi er derfor et stærkt valg til at stå for lægningen af din indkørsel.\n\nVores kompetente medarbejdere give dig professionel rådgivning og vejledning i forhold til din nuværende eller helt nye indkørsel og hvad der ville være bedst.\n\nVælg derfor os hvis du ønsker:`,
        bullets: [
          "Erfaring og ekspertise",
          "Kvalitetsmaterialer",
          "Skræddersyet design",
          "Professionel udførelse"
        ],
        afterText: `Vi fjerner selvfølgelig altid den gamle belægning inden vi lægger en ny indkørsel for dig, hvilket tæller med i den samlede pris.`
      },
      {
        heading: "Kontakt os og få et tilbud på en ny indkørsel",
        text: `Ønsker du at få en ny indkørsel, der skiller sig ud og giver dig et imponerende første indtryk? Så kontakt Elmegaarden Have og Anlæg i dag.\n\nVores dedikerede team står klar til at hjælpe dig med at realisere dine drømme om en smuk og praktisk ny indkørsel.\n\nRing til os på telefon 20 66 15 17 eller via mail rasmus@elmegaardenhaveoganlaeg.dk, og få et uforpligtende tilbud.\n\nVi ser frem til at hjælpe dig med at skabe den perfekte indkørsel.`
      }
    ],
    galleryImages: [
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/ny-indkoersel_7300721c.jpeg",
        alt: "Ny indkørsel"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningssten-til-ny-indkoersel.jpeg",
        alt: "Belægningssten til ny indkørsel"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/ny-indkoersel-i-hadsund-arden-hobro.jpeg",
        alt: "Ny indkørsel i Hadsund Arden og Hobro"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280066754-165044342559814-6222938183290513673-n_5ef90c3e.jpg",
        alt: "Indkørselsprojekt"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280099641-165044332559815-7254803062905654258-n_99f858c0.jpg",
        alt: "Indkørsel fliselægning"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280459717-166065415791040-7205502779521114604-n_f3b664e9.jpg",
        alt: "Professionelt indkørselsarbejde"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280579995-166065429124372-2143351238162849071-n-1_3405e277.jpg",
        alt: "Belægningssten indkørsel"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280710454-166065399124375-3539428371481911749-n_c92511c7.jpg",
        alt: "Færdig indkørsel"
      }
    ]
  },
  {
    slug: "belaegningsarbejde",
    menuTitle: "Belægning",
    title: "Belægningsarbejde | Hobro, Arden, Hadsund & omegn | Få tilbud",
    metaDescription: "Skal du have belagt din indkørsel, terrasse eller andet? Så kan Elmegaarden Have og Anlæg stå for dit belægningsarbejde for dig. Få et tilbud i dag.",
    heading: "Belægningsarbejde",
    subtitle: "Belægningsarbejde i Hobro, Arden & Hadsund",
    sections: [
      {
        text: `Skal du have belagt din indkørsel, terrasse eller andet? Så kan Elmegaarden Have og Anlæg stå for dit belægningsarbejde. Vi servicere både private og erhvervskunder.\n\nVi udfører belægningen for dig i Hobro, Hadsund, Arden og omegn.\n\nUanset opgavens omfang, så kan vi stå for arbejdet, samt rådgive og vejlede i forhold til hvad der er mest optimalt for dig.\n\nHos Elmegaarden Have og Anlæg tilbyder vi udelukkende belægninger til konkurrencedygtige priser, og vi forlader aldrig en opgave før du som kunde er tilfreds med resultatet.`
      },
      {
        heading: "Belægningsarbejde efter dine ønsker",
        text: `Uanset hvilken form for belægning du ønsker, så kan vi udfører opgaven for dig. For os betyder det allermest, at du som kunde får lige det du ønsker dig, og derfor tager vi også en god dialog omkring dine ønsker, inden vi går i gang med opgaven.\n\nVi vil selvfølgelig rådgive og vejlede dig omkring dine ønsker, så du også får det bedste og mest holdbare resultat.\n\nInden for belægningsarbejde udfører vi blandt andet:`,
        bullets: [
          "Lægning af terrasse",
          "Indkørsel",
          "Stisystemer i haven",
          "Trapper",
          "Støttemure m.m."
        ],
        afterText: `Så hvis du har brug for professionel hjælp til at, tænke ud af boksen i forhold til belægningsarbejdet for dig - så kan du altid kontakte os på 20 66 15 17 eller sende en mail til rasmus@elmegaardenhaveoganlaeg.dk, så vender vi tilbage til dig hurtigst muligt.`
      },
      {
        heading: "Fra traditionel til moderne - Vi har det hele",
        text: `Vi forstår, at hver have er unik, og at forskellige mennesker har forskellige præferencer og smag. Derfor tilbyder vi et bredt udvalg af belægningsmaterialer og stilarter, så du kan vælge det, der passer bedst til din have og personlige stil.\n\nHvis du foretrækker det traditionelle look, kan vi tilbyde flotte brosten, der skaber en rustik og charmerende atmosfære.\n\nEr du derimod til det moderne og minimalistiske, har vi også et udvalg af elegante og stilrene fliser og betonplader.\n\nUanset hvilken stil du foretrækker, kan vi skabe en belægning, der passer perfekt til din have.`
      },
      {
        heading: "Få et uforpligtende tilbud på belægningsarbejde",
        text: `Når det kommer til belægninger og generelt haveanlæg, så er det kun fantasien der sætter grænser, så selvom du har et projekt som er udover det sædvanlige er du velkommen til at give os et kald - også finder vi en god løsning til dig.\n\nRing til os på 20 66 15 17 eller send en mail til rasmus@elmegaardenhaveoganlaeg.dk\n\nVores erfarne team står klar til at lytte til dine ønsker, give dig rådgivning for anlægning af den perfekte belægning til dit hjem.`
      }
    ],
    galleryImages: [
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde_47136c38.jpeg",
        alt: "Belægningsarbejde"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde-2_83331c0f.jpeg",
        alt: "Belægningsarbejde 2"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde-i-hadsund-arden-hobro_0ca9232c.jpeg",
        alt: "Belægningsarbejde i Hadsund Arden og Hobro"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningssten_4112fdfc.jpeg",
        alt: "Belægningssten"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegning_1900ac31.jpg",
        alt: "Belægning"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegning-til-indkoersel_c8268d18.jpg",
        alt: "Belægning til indkørsel"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/ny-belaegning_00de6f62.jpg",
        alt: "Ny belægning"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde_d00038d0.jpg",
        alt: "Belægningsarbejde"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde-med-fliser_22d9abe3.jpg",
        alt: "Belægningsarbejde med fliser"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde-til-indkoersel_52249cca.jpg",
        alt: "Belægningsarbejde til indkørsel"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/privat-belaegningsarbejde_b06969f0.jpg",
        alt: "Privat belægningsarbejde"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/professionel-belaegningsarbejde_94f19f7b.jpg",
        alt: "Professionel belægningsarbejde"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegning-af-gangsti_4105b864.jpg",
        alt: "Belægning af gangsti"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde-privat_28509d4c.jpg",
        alt: "Belægningsarbejde privat"
      }
    ]
  },
  {
    slug: "stoettemur-opbygning",
    menuTitle: "Støttemur",
    title: "Støttemur opbygning | Hobro, Arden & Hadsund | Ring i dag",
    metaDescription: "Skal du have opsat en støttemur i haven? eller ønsker du niveauforskelle i din have? Så kontakt os gerne i dag og få et tilbud.",
    heading: "Støttemur opbygning",
    subtitle: "Støttemur opbygning i Hobro, Arden & Hadsund",
    sections: [
      {
        text: `Hos Elmegaarden Have og Anlæg har vi mange års erfaring med støttemur opbygning. En støttemur er et eksempel på at noget praktisk ikke behøver at være grimt, da en støttemur kan laves i så mange forskellige sten, og designs - så de fremstår dekorative.\n\nSå hvis du går og drømmer om at få opbygning af støttemur eller andre former for belægninger i din have - så ring endelig til os, vi kører gerne i Hobro, Arden, Hadsund og resten af Nordjylland.`
      },
      {
        heading: "Få et dynamisk udtryk i haven med en støttemur opbygning",
        text: `Man kan anvende støttemure på forskellige måder, som udgangspunkt anvendes den til at støtte jorden og holde den på plads, så du kan nyde godt af niveauforskelle i terrænet i din have.\n\nStøttemure kan anvendes på forskellige måder alt efter hvad jeres ønsker er, men fx kan de anvendes ved højbede, til terrassen eller hvis du ønsker en trappe til et nedgravet areal, eller hvis du bare ønsker en stor ændring i forhold til niveauet af dit terræn i haven.\n\nEn støttemur opbygning, er med til at give have et lidt mere dynamisk udtryk.\n\nNår det kommer til valg af materialer er der mange muligheder, typisk anvendes der beton eller granit til konstruktionen af en støttemur, da dette er den mest solide løsning.\n\nDet er kun fantasien der sætter grænser for, hvilket design i ønsker i forhold til jeres støttemur opbygning - I kan altid tage fat i os, så vil vi meget gerne vejlede og rådgive i forhold til hvad der kunne være den bedste løsning for jer.`
      },
      {
        heading: "Bæredygtig opbygning af støttemur",
        text: `Vi er dedikeret til at skabe støttemursløsninger, der ikke kun opfylder funktionelle behov, men også respekterer miljøet. Vi anvender miljøvenlige materialer, der er udvalgt med omhu for at minimere vores påvirkning af naturen.\n\nVi tror på at reducere vores aftryk, ved at implementere genanvendelige konstruktionsteknikker. Vores opbygning af støttemure, er designet med fokus på at maksimere genanvendeligheden af materialer, hvilket bidrager til at skabe mere bæredygtige udendørs rum.\n\nVi stræber efter at skabe støttemursløsninger, der naturligt integrerer sig i det omkringliggende miljø. Vores designs tager hensyn til landskabets naturlige karakteristika og understreger biodiversitet, så din støttemur ikke kun er en strukturel nødvendighed, men også en harmonisk del af naturen.`
      },
      {
        heading: "Få et tilbud på opbygning af støttemur",
        text: `Ønsker i at få et tilbud på en støttemur? eller mangler i inspiration til jeres kommende støttemur? Så er i mere end velkommen til at ringe til os, og så tager vi en snak om jeres muligheder og så finder vi frem til den bedste løsning for jer.\n\nKontakt os i dag på telefon 20 66 15 17, eller ved at sende en mail til rasmus@elmegaardenhaveoganlaeg.dk.\n\nVi står klar med en støttemur i Hobro, Arden & Hadsund.`
      }
    ],
    galleryImages: [
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/stoettemur-opbygning-i-arden_bfd056f5.jpeg",
        alt: "Støttemur opbygning i Arden"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/647f31383a099.jpeg",
        alt: "Støttemur opbygning"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/stoettemur-opbygning-i-hadsund.jpeg",
        alt: "Støttemur opbygning i Hadsund"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/647f313843f8c.jpeg",
        alt: "Støttemur detalje"
      }
    ]
  },
  {
    slug: "vedligeholdelse-af-groenne-omraader",
    menuTitle: "Vedligeholdelse af grønne områder",
    title: "Vedligehold og nyanlæg af din have i Hobro - Ring i dag",
    metaDescription: "Elmegaarden Have og Anlæg kan stå for pleje samt nyanlæg af dine grønne områder. Kontakt os i dag og få et tilbud",
    heading: "Vedligeholdelse af grønne områder",
    sections: [
      {
        text: `Hos Elmegaarden Have og Anlæg kan vi stå for pleje samt nyanlæg af dine grønne områder. Hvis du ikke selv har tiden til at pleje haven, så kan vi gøre det for dig!\n\nVi kan stå for plejen af dine grønne områder, så du kan fokusere på de ting der er lidt mere vigtige for dig.\n\nVi servicere kunder i Hobro, Arden, Hadsund og resten af Nordjylland.\n\nHos Elmegaarden Have og Anlæg kan vi udfører alt inden for pleje af haver blandt andet:`,
        bullets: [
          "Nyanlæg af have",
          "Beskæring af træer og buske",
          "Hækklipning",
          "Træfældning",
          "Græsslåning"
        ]
      },
      {
        heading: "Kontakt os og få et tilbud på dine grønne områder i Hobro, Arden & Hadsund",
        text: `Du er velkommen til at kontakte os på 20 66 15 17 og så tager vi en snak om din have.`
      }
    ],
    galleryImages: [
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/img-3346.jpeg",
        alt: "Grøn vedligeholdelse"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/img-5169.jpeg",
        alt: "Beskæring og havepleje"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/img-5171.jpeg",
        alt: "Hækklipning"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/img-5172.jpeg",
        alt: "Græsslåning og trimning"
      }
    ]
  }
];

export const galleriSubpages = [
  {
    slug: "blomster-bed",
    title: "Blomster bed | Elmegaarden Have og Anlæg",
    metaDescription: "Blomster bed lavet i Hadsund",
    ogImage: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/645a442217253_1503c6ee.jpeg",
    heading: "Blomster bed",
    description: "Blomster bed lavet i Hadsund",
    images: [
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/645a442217253_1503c6ee.jpeg",
        alt: "Blomster bed i Hadsund"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/645a442232287.jpeg",
        alt: "Blomster bed anlæg"
      }
    ]
  },
  {
    slug: "stoettemur-op-mod-nabo-grund",
    title: "Støttemur op mod nabo grund | Elmegaarden Have og Anlæg",
    metaDescription: "Ny støttemur mod nabo så grunden kunne jævnes af og såes græs",
    ogImage: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/stoettemur-opbygning-i-arden_bfd056f5.jpeg",
    heading: "Støttemur op mod nabo grund",
    description: "Ny støttemur mod nabo så grunden kunne jævnes af og såes græs",
    images: [
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/stoettemur-opbygning-i-arden_bfd056f5.jpeg",
        alt: "Støttemur opbygning i Arden"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/647f31383a099.jpeg",
        alt: "Støttemur op mod nabogrund"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/stoettemur-opbygning-i-hadsund.jpeg",
        alt: "Støttemur opbygning i Hadsund"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/647f313843f8c.jpeg",
        alt: "Støttemur detaljer"
      }
    ]
  },
  {
    slug: "terrasse",
    title: "Terrasse | Elmegaarden Have og Anlæg",
    metaDescription: "Se eksempler på vores terrasseopbygninger og terrasser i sten.",
    ogImage: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/terrasse-i-sten_34f4226c.jpg",
    heading: "Terrasse",
    images: [
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/terrasse-i-sten_34f4226c.jpg",
        alt: "Terrasse i sten"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/terrasseopbygning.jpg",
        alt: "Terrasseopbygning"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/terrasse-i-niveauer.jpg",
        alt: "Terrasse i niveauer"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/opbygning-af-terrasse-til-hus.jpg",
        alt: "Opbygning af terrasse til hus"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/ny-opbygning-af-terrasse-i-brosten.jpg",
        alt: "Ny opbygning af terrasse i brosten"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/terrasseopbygning-med-stoettemur.jpg",
        alt: "Terrasseopbygning med støttemur"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/professionel-opbygning-af-terrasse.jpg",
        alt: "Professionel opbygning af terrasse"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/opbygning-af-terrasse.jpg",
        alt: "Opbygning af terrasse"
      }
    ]
  },
  {
    slug: "indkoersel",
    title: "Indkørsel | Elmegaarden Have og Anlæg",
    metaDescription: "Se eksempler på vores arbejde med nye indkørsler og brolægning.",
    ogImage: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280066754-165044342559814-6222938183290513673-n_5ef90c3e.jpg",
    heading: "Indkørsel",
    images: [
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280066754-165044342559814-6222938183290513673-n_5ef90c3e.jpg",
        alt: "Indkørsel belægning"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280099641-165044332559815-7254803062905654258-n_99f858c0.jpg",
        alt: "Indkørsel sten"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280459717-166065415791040-7205502779521114604-n_f3b664e9.jpg",
        alt: "Indkørsel lægning"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280579995-166065429124372-2143351238162849071-n-1_3405e277.jpg",
        alt: "Indkørsel brolægning"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280710454-166065399124375-3539428371481911749-n_c92511c7.jpg",
        alt: "Færdig indkørsel"
      }
    ]
  },
  {
    slug: "indkoersel-med-terrasse-enden-lagt-i-30x60",
    title: "Indkørsel med terrasse for enden lagt i 30x60 | Elmegaarden Have og Anlæg",
    metaDescription: "Indkørsel med terrasse for enden lagt i 30x60 | Elmegaarden Have og Anlæg",
    ogImage: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/ny-indkoersel_7300721c.jpeg",
    heading: "Indkørsel med terrasse for enden lagt i 30x60",
    images: [
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/ny-indkoersel_7300721c.jpeg",
        alt: "Ny indkørsel"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningssten-til-ny-indkoersel.jpeg",
        alt: "Belægningssten til ny indkørsel"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/ny-indkoersel-i-hadsund-arden-hobro.jpeg",
        alt: "Ny indkørsel i Hadsund Arden og Hobro"
      }
    ]
  },
  {
    slug: "60x60-fliser-i-hadsund",
    title: "60x60 fliser i Hadsund | Elmegaarden Have og Anlæg",
    metaDescription: "60x60 fliser lagt under ny terrasse og lavet 3 støttemure samt lagt fliser på de 3 reposer",
    ogImage: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde_47136c38.jpeg",
    heading: "60x60 fliser i Hadsund",
    description: "60x60 fliser lagt under ny terrasse og lavet 3 støttemure samt lagt fliser på de 3 reposer",
    images: [
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde_47136c38.jpeg",
        alt: "Belægningsarbejde"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde-2.jpeg",
        alt: "Belægningsarbejde 2"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde-i-hadsund-arden-hobro.jpeg",
        alt: "Belægningsarbejde i Hadsund Arden og Hobro"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningssten.jpeg",
        alt: "Belægningssten"
      }
    ]
  },
  {
    slug: "belaegning",
    title: "Belægning | Elmegaarden Have og Anlæg",
    metaDescription: "Se eksempler på vores belægningsarbejde og brolægning i Nordjylland.",
    ogImage: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegning_1900ac31.jpg",
    heading: "Belægning",
    images: [
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegning_1900ac31.jpg",
        alt: "Belægning"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegning-til-indkoersel.jpg",
        alt: "Belægning til indkørsel"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/ny-belaegning.jpg",
        alt: "Ny belægning"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde.jpg",
        alt: "Belægningsarbejde"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde-med-fliser.jpg",
        alt: "Belægningsarbejde med fliser"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde-til-indkoersel.jpg",
        alt: "Belægningsarbejde til indkørsel"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/privat-belaegningsarbejde.jpg",
        alt: "Privat belægningsarbejde"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/professionel-belaegningsarbejde.jpg",
        alt: "Professionel belægningsarbejde"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegning-af-gangsti.jpg",
        alt: "Belægning af gangsti"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/belaegningsarbejde-privat.jpg",
        alt: "Belægningsarbejde privat"
      }
    ]
  },
  {
    slug: "diverse",
    title: "Diverse | Elmegaarden Have og Anlæg",
    metaDescription: "Diverse have og anlægsopgaver udført i Nordjylland.",
    ogImage: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/241339281-115391594191756-1596522062498823638-n_570d72b2.jpg",
    heading: "Diverse",
    images: [
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/241339281-115391594191756-1596522062498823638-n_570d72b2.jpg",
        alt: "Diverse haveprojekt"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/241671860-115391990858383-9086179976769254286-n.jpg",
        alt: "Diverse havearbejde"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/241673922-115391607525088-7228905637875262507-n.jpg",
        alt: "Diverse anlæg"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/263682111-134805335583715-6552948861617918243-n.jpg",
        alt: "Diverse uderum"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/273276492-147298297667752-5473106841734708737-n.jpg",
        alt: "Diverse havebillede"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/273290245-147298284334420-6115047199873506864-n.jpg",
        alt: "Diverse stenarbejde"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/275260825-153013713762877-929186693385409259-n.jpg",
        alt: "Diverse haveomlægning"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280034825-165044309226484-7560631712361902042-n.jpg",
        alt: "Diverse flisearbejde"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280538060-166065442457704-6536168061921769150-n.jpg",
        alt: "Diverse grønt anlæg"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280579995-166065429124372-2143351238162849071-n.jpg",
        alt: "Diverse haveopgave"
      },
      {
        src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/280602936-166065359124379-790455160987967279-n.jpg",
        alt: "Diverse aflevering"
      }
    ]
  }
];
